export * from './mouse-tracking.interface';
export * from './mouse-tracking.mock';
export * from './mouse-tracking.service';
export const MOUSE_TRACKING_SERVICE = Symbol('MouseTrackingService');
